var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFamilia(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 261,
    height: 261,
    viewBox: "0 0 261 261",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #002e6b;\n        opacity: 0.82;\n      }\n\n      .cls-2, .cls-4 {\n        fill: none;\n      }\n\n      .cls-2 {\n        stroke: #0abaff;\n        stroke-width: 20px;\n      }\n\n      .cls-3 {\n        stroke: none;\n      }\n\n      .cls-5 {\n        filter: url(#Ellipse_2);\n      }\n\n      .cls-6 {\n        filter: url(#Ellipse_1);\n      }\n    "), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_1",
    x: 0,
    y: 0,
    width: 261,
    height: 261,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#002e6b",
    floodOpacity: 0.471
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_2",
    x: 13.5,
    y: 11.5,
    width: 234,
    height: 234,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#002e6b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(-1213.5 -500.5)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-6",
    transform: "matrix(1, 0, 0, 1, 1213.5, 500.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1-2",
    "data-name": "Ellipse 1",
    className: "cls-1",
    cx: 108,
    cy: 108,
    r: 108,
    transform: "translate(22.5 17.5)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-5",
    transform: "matrix(1, 0, 0, 1, 1213.5, 500.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2-2",
    "data-name": "Ellipse 2",
    className: "cls-2",
    transform: "translate(22.5 17.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 108,
    cy: 108,
    r: 108
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 108,
    cy: 108,
    r: 98
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFamilia);
export default __webpack_public_path__ + "static/media/Familia.46582a3651395b615bdb6a5a83390f44.svg";
export { ForwardRef as ReactComponent };